<template>
    <div class="google-maps-container smph-hden">
        <div id="GoogleMaps" class="google-maps"></div>
        <div class="legend cf">
            <div class="item cf">
                <div class="sprite-icon-sedi fl-l"></div>
                <div class="fl-l text">{{ localizer.get("App.Common.Locations") }}</div>
            </div>
            <div class="item cf">
                <div class="sprite-icon-filialeitaliana fl-l"></div>
                <div class="fl-l text">{{ localizer.get("App.Common.ItalianBranch") }}</div>
            </div>
            <div class="item cf">
                <div class="sprite-icon-vlsfilialeestera fl-l"></div>
                <div class="fl-l text">{{ localizer.get("App.Common.VLSForeignBranch") }}</div>
            </div>
            <div class="item cf">
                <div class="sprite-icon-vlsterminal fl-l"></div>
                <div class="fl-l text">{{ localizer.get("App.Common.VLSTerminal") }}</div>
            </div>
            <div class="item cf">
                <div class="sprite-icon-vlsbranch fl-l"></div>
                <div class="fl-l text">{{ localizer.get("App.Common.VLSBranch") }}</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import Localizer from '@Scripts/Common/Localizer';
import GoogleMapsHelper from '@Scripts/Infrastructure/GoogleMapsHelper';

const localizer = Localizer;
const googleMapsHelper = GoogleMapsHelper;

(async () => {
    await googleMapsHelper.loadMap();
})()

getGeoMarkers();

function getGeoMarkers() {
    const markerElements = document.querySelectorAll('.google-maps-marker');
    markerElements.forEach((element: any, i: number) => {
        const markerIcon = element.querySelector('input[name="MarkerIcon"]')?.value;
        const markerLatitude = element.querySelector('input[name="Latitude"]')?.value;
        const markerLongitude = element.querySelector('input[name="Longitude"]')?.value;
        const markerTitle = element.querySelector('input[name="MarkerTitle"]')?.value;
        const markerContents = element.querySelector('.infowindow')?.innerHTML;
        const icon = markerIcon && markerIcon.trim().length > 0 ? markerIcon : 'gmaps-marker-sedi@2x.png';

        const latlng = new (window as any).google.maps.LatLng(Number(markerLatitude), Number(markerLongitude));
        googleMapsHelper.addMarker(i.toString(), markerTitle, markerContents, latlng.lat(), latlng.lng(), icon);
    });
}
</script>